import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const authHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` }
});
